import { localizePathname, stripLocalePrefix } from "@/lib/locale-routing"

type QueryValue = string | number | boolean | null | undefined

export function localizeWebAccountPath(pathname: string, lng: string): string {
  return localizePathname(pathname, lng)
}

export function localizePathWithQuery(
  pathname: string,
  lng: string,
  query?: Record<string, QueryValue>
): string {
  const normalizedPathname = stripLocalePrefix(pathname)
  const localizedPathname = localizePathname(normalizedPathname, lng)
  const searchParams = new URLSearchParams()

  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && `${value}`.length > 0) {
      searchParams.set(key, `${value}`)
    }
  })

  const search = searchParams.toString()
  return search ? `${localizedPathname}?${search}` : localizedPathname
}

export function localizeFlutterAccountPath(
  pathname: string,
  lng: string,
  query?: Record<string, QueryValue>
): string {
  return localizePathWithQuery(pathname, lng, query)
}
